import React from 'react';
import { Target, Home, GraduationCap, Trophy, CheckCircle2 } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const audiences = [{
  icon: Target,
  title: 'Atletas estancados',
  desc: 'Intermedios y avanzados que repiten lo mismo sin progresar a los trucos de nivel.'
}, {
  icon: Home,
  title: 'Entrenás en casa o parque',
  desc: 'Con una barra, anillas o el piso te alcanza. Sin gimnasio, sin equipamiento caro.'
}, {
  icon: GraduationCap,
  title: 'Atletas que quieren dar clases',
  desc: 'Querés transmitir tu conocimiento y convertirte en coach de calistenia.',
  highlight: true
}, {
  icon: Trophy,
  title: 'Buscás trucos avanzados',
  desc: 'Vas por el Front Lever, Plancha, Muscle Up estricto, HSPU u OAPU.'
}];
export function TargetAudience() {
  return <section className="py-10 md:py-20 relative" data-id="element-336">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-337">
        <FadeIn className="text-center mb-8 md:mb-10" data-id="element-338">
          <div className="inline-flex items-center gap-2 bg-brand-orange/10 border border-brand-orange/30 text-brand-orange px-3 py-1 rounded-full text-[10px] md:text-xs font-bold tracking-widest mb-4" data-id="element-339">
            <CheckCircle2 className="w-3 h-3" data-id="element-340" /> ¿PARA QUIÉN ES?
          </div>
          <h2 className="text-2xl md:text-4xl leading-tight max-w-3xl mx-auto" data-id="element-341">
            Diseñado para vos si{' '}
            <span className="text-brand-orange" data-id="element-342">
              querés llevar tu calistenia al próximo nivel
            </span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4" data-id="element-343">
          {audiences.map((aud, i) => {
          const Icon = aud.icon;
          return <FadeIn key={i} delay={i * 0.05} data-id="element-344">
                <div className={`group relative flex items-start gap-3 md:gap-4 rounded-xl border p-4 md:p-5 transition-all duration-300 h-full overflow-hidden ${aud.highlight ? 'bg-gradient-to-br from-brand-orange/10 to-brand-card border-brand-orange/50 shadow-[0_0_20px_rgba(255,107,26,0.1)]' : 'bg-brand-card border-brand-border hover:border-brand-orange/40'}`} data-id="element-345">
                  {aud.highlight && <span className="absolute top-2 right-2 bg-brand-orange text-white text-[9px] font-bold px-2 py-0.5 rounded-full tracking-wider" data-id="element-346">
                      NUEVO
                    </span>}

                  <div className={`shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-lg flex items-center justify-center transition-colors ${aud.highlight ? 'bg-brand-orange text-white' : 'bg-brand-dark text-brand-orange border border-brand-border group-hover:bg-brand-orange/10'}`} data-id="element-347">
                    <Icon className="w-5 h-5 md:w-6 md:h-6" data-id="element-348" />
                  </div>

                  <div className="flex-grow min-w-0" data-id="element-349">
                    <h3 className="text-sm md:text-base font-bold leading-tight mb-1" data-id="element-350">
                      {aud.title}
                    </h3>
                    <p className="text-[11px] md:text-xs text-brand-muted leading-snug" data-id="element-351">
                      {aud.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>

        <FadeIn delay={0.3} className="text-center mt-6 md:mt-8" data-id="element-352">
          <p className="text-xs md:text-sm text-brand-muted" data-id="element-353">
            ¿No estás seguro si es para vos?{' '}
            <a href="#pricing" className="text-brand-orange font-bold hover:underline" data-id="element-354">
              Tenés 7 días de garantía →
            </a>
          </p>
        </FadeIn>
      </div>
    </section>;
}